import { useQuery } from '@tanstack/react-query';
import { OWASReportService } from '@/infra/services/owas-report';
import { OWAS_QUERY_KEYS } from '../enums';
interface GetOWASReportParams {
	organization_id: string;
	company_id: string;
	file_id: string;
}

const Service = OWASReportService.getInstance();

export const useGetOWASReport = (params: GetOWASReportParams) => {
	return useQuery([OWAS_QUERY_KEYS.GET_REPORT, params], () => Service.getReport(params), {
		enabled: !!params?.organization_id && !!params?.company_id && !!params?.file_id
	});
};
